import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store/store'
import {closeSub} from '../mq'
import {removeToken} from './auth'

function getapi () {
  let aaa = window.location.protocol + '//' + window.location.host + '/api/v1/web/'
  let aa = window.location.host
  let arr = aa.split(':')
  if (arr[0] === 'localhost') {
    // return 'https://jiaold.com/api/v1'
    return 'https://kangnh.com/api/v1/web/'
  } else {
    return aaa
  }
}

// 创建axios实例
const service = axios.create({
  baseURL: getapi(), // api的base_url
  timeout: 5000 // 请求超时时间
})

service.axios = axios

// request拦截器
service.interceptors.request.use(config => {
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    axios.timeout = 5000
    const res = response.data
    if (response.config.url === '/food/upload-image') {
      return response
    }
    // console.log(res)
    if (res.code !== 200) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 3 * 1000
      })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        let urlPath = window.location.pathname
        MessageBox.confirm('你已被登出,请重新登录', '确定登出', {
          closeOnClickModal: false,
          showClose: false,
          showCancelButton: false,
          confirmButtonText: '重新登录',
          type: 'warning'
        }).then(() => {
          removeToken()
          closeSub()
          store.commit('set_path', true)
          // location.href = '/'
          location.href = urlPath
        })
      }
      return Promise.reject(new Error('error'))
    } else {
      return response.data
    }
  },
  error => {
    console.log(error, error.response.code)
    if (error.response.data.code === 20004) {
      let urlPath = window.location.pathname
      // location.href = '/'
      MessageBox.confirm('你已被登出,请重新登录', '确定登出', {
        closeOnClickModal: false,
        showClose: false,
        showCancelButton: false,
        confirmButtonText: '重新登录',
        type: 'warning'
      }).then(() => {
        removeToken()
        closeSub()
        store.commit('set_path', true)
        store.commit('set_out_alarm', [])
        // location.href = '/'
        location.href = urlPath
      })
    } else {
      Message({
        message: error.response.data.msg,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js